module.exports = __webpack_public_path__ + "media/our_mission/photo_2-be0f0268.webp";